import { render, staticRenderFns } from "./Freshread.vue?vue&type=template&id=850f3a8a&scoped=true&"
import script from "./Freshread.vue?vue&type=script&lang=js&"
export * from "./Freshread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850f3a8a",
  null
  
)

export default component.exports